var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodCategoryOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81818 0C0.813637 0 0 0.813637 0 1.81818V18.1818C0 19.1864 0.813637 20 1.81818 20H18.1818C19.1864 20 20 19.1864 20 18.1818V1.81818C20 0.813637 19.1864 0 18.1818 0H1.81818ZM1.81818 1.81818H18.1818V18.1818H1.81818V1.81818ZM10 4.54545C6.98754 4.54545 4.54545 6.98754 4.54545 10C4.54545 13.0125 6.98754 15.4545 10 15.4545C13.0125 15.4545 15.4545 13.0125 15.4545 10C15.4545 6.98754 13.0125 4.54545 10 4.54545Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodCategoryOthers);
export default __webpack_public_path__ + "static/media/food-category-others.65b4adf6ba296e0b7fdcb47d7e1b9cf9.svg";
export { ForwardRef as ReactComponent };